import React, { useState, useEffect } from 'react';
import FornecedorPicker from './FornecedorPicker';
import ContratoPicker from './ContratoPicker';
import DescricaoEntregaPicker from './DescricaoEntregaPicker';
import AcaoGovernamentalPicker from './AcaoGovernamentalPicker';
import FonteRecursoPicker from './FonteRecursoPicker';
import ElementoDespesaPicker from './ElementoDespesaPicker';
import SubelementoDespesaPicker from './SubelementoDespesaPicker';
import * as DescricaoEntregaApi from '../../DescricaoEntregaService';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';
import DataMaskInput from '../masks/DataMaskInput';
import SaveValidationModal from './SaveValidationModal';

function ContratoModal({ show, contrato, contratoPai: contratoPaiProp, onClose, onSave }) {
  const anoBase = parseInt(localStorage.getItem('anoBase'), 10) || new Date().getFullYear();
  const [modo, setModo] = useState('');
  const [contratoPaiSelecionado, setContratoPaiSelecionado] = useState(null);
  const [contratosParaAditivar, setContratosParaAditivar] = useState([]);
  const [showContratoPicker, setShowContratoPicker] = useState(false);
  const contratoPai = contratoPaiProp || contratoPaiSelecionado;
  const isAditivo = !!contratoPai;
  const criando = !contrato && !contratoPai;
  const mostrarEscolha = criando && !modo;
  const mostrarSelecaoPai = criando && modo === 'ADITIVO' && !contratoPai;
  const [formData, setFormData] = useState({
    numContrato: '',
    ano: anoBase,
    idFornecedor: '',
    numProcesso: '',
    nomeModalidade: '',
    numModalidade: '',
    dataInicio: '',
    dataFim: '',
    dataRescisao: '',
    objeto: '',
    descricaoEntrega: '',
    idFonteRecurso: '',
    idAcaoGovernamental: '',
    idElementoDespesa: '',
    idSubelementoDespesa: '',
  });
  const [tipoAditivo, setTipoAditivo] = useState('');
  const [itensAditivo, setItensAditivo] = useState([]);
  const [justificativa, setJustificativa] = useState('');
  const [fornecedores, setFornecedores] = useState([]);
  const [showFornecedorPicker, setShowFornecedorPicker] = useState(false);
  const [modalidades, setModalidades] = useState([]);
  const [acoes, setAcoes] = useState([]);
  const [fontes, setFontes] = useState([]);
  const [elementos, setElementos] = useState([]);
  const [subelementos, setSubelementos] = useState([]);
  const [showAcaoPicker, setShowAcaoPicker] = useState(false);
  const [showFontePicker, setShowFontePicker] = useState(false);
  const [showElementoPicker, setShowElementoPicker] = useState(false);
  const [showSubelementoPicker, setShowSubelementoPicker] = useState(false);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSaveValidation, setShowSaveValidation] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [validationWarnings, setValidationWarnings] = useState([]);
  const token = localStorage.getItem('token');
  const vinculo = JSON.parse(localStorage.getItem('vinculo'));
  const user = JSON.parse(localStorage.getItem('user'));
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (!show) {
      setModo('');
      setContratoPaiSelecionado(null);
      setContratosParaAditivar([]);
      setShowContratoPicker(false);
      setTipoAditivo('');
      setItensAditivo([]);
      setJustificativa('');
      return;
    }

    if (!contrato && !contratoPaiProp) {
      axios
        .get(`${API_BASE_URL.CONTRATO}/all`,
          { params: { idEntidade: vinculo.idEntidade, anoBase },
            headers: { Authorization: `Bearer ${token}` } }
        )
        .then(result => {
          const lista = Array.isArray(result.data) ? result.data.filter(c => c.tipoCadastro !== 'ADITIVO') : [];
          setContratosParaAditivar(lista);
        })
        .catch(err => {
          console.error('Erro ao carregar contratos para aditivo:', err);
          setContratosParaAditivar([]);
        });
    }

    if (show) {
      // Carregar fornecedores
      axios
        .get(`${API_BASE_URL.FORNECEDOR}/entidade/${vinculo.idEntidade}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          setFornecedores(result.data);
        })
        .catch(error => {
          console.error('Erro ao carregar fornecedores:', error);
        });

      // Carregar modalidades
      axios
        .get(`${API_BASE_URL.MODALIDADE}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          setModalidades(result.data);
        })
        .catch(error => {
          console.error('Erro ao carregar modalidades:', error);
        });

      // Carregar ações governamentais
      axios
        .get(`${API_BASE_URL.ACAO_GOVERNAMENTAL}/entidade/${vinculo.idEntidade}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          setAcoes(result.data);
        })
        .catch(error => {
          console.error('Erro ao carregar ações governamentais:', error);
        });

      // Carregar fontes de recurso
      axios
        .get(`${API_BASE_URL.FONTE_RECURSO}/entidade/${vinculo.idEntidade}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          setFontes(result.data);
        })
        .catch(error => {
          console.error('Erro ao carregar fontes de recurso:', error);
        });

      // Carregar elementos de despesa
      axios
        .get(`${API_BASE_URL.ELEMENTO_DESPESA}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          setElementos(result.data);
        })
        .catch(error => {
          console.error('Erro ao carregar elementos de despesa:', error);
        });

      // Carregar subelementos de despesa
      axios
        .get(`${API_BASE_URL.SUBELEMENTO_DESPESA}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          setSubelementos(result.data);
        })
        .catch(error => {
          console.error('Erro ao carregar subelementos de despesa:', error);
        });

      const formatDate = (date) => {
        if (!date) return '';
        if (Array.isArray(date)) {
          const [year, month, day] = date;
          return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
        if (typeof date === 'string') {
          return date.split('T')[0];
        }
        return '';
      };

      if (contrato) {
        setFormData({
          numContrato: contrato.numContrato || '',
          ano: contrato.ano || anoBase,
          idFornecedor: contrato.idFornecedor || '',
          numProcesso: contrato.numProcesso || '',
          nomeModalidade: contrato.nomeModalidade || '',
          numModalidade: contrato.numModalidade || '',
          dataInicio: formatDate(contrato.dataInicio),
          dataFim: formatDate(contrato.dataFim),
          dataRescisao: formatDate(contrato.dataRescisao),
          objeto: contrato.objeto || '',
          descricaoEntrega: contrato.descricaoEntrega || '',
          idFonteRecurso: contrato.idFonteRecurso || '',
          idAcaoGovernamental: contrato.idAcaoGovernamental || '',
          idElementoDespesa: contrato.idElementoDespesa || '',
          idSubelementoDespesa: contrato.idSubelementoDespesa || '',
        });
      } else if (contratoPai) {
        setFormData({
          numContrato: '',
          ano: contratoPai.ano || anoBase,
          idFornecedor: contratoPai.idFornecedor || '',
          numProcesso: contratoPai.numProcesso || '',
          nomeModalidade: contratoPai.nomeModalidade || '',
          numModalidade: contratoPai.numModalidade || '',
          dataInicio: formatDate(contratoPai.dataInicio),
          dataFim: formatDate(contratoPai.dataFim),
          dataRescisao: '',
          objeto: contratoPai.objeto || '',
          descricaoEntrega: contratoPai.descricaoEntrega || '',
          idFonteRecurso: contratoPai.idFonteRecurso || '',
          idAcaoGovernamental: contratoPai.idAcaoGovernamental || '',
          idElementoDespesa: contratoPai.idElementoDespesa || '',
          idSubelementoDespesa: contratoPai.idSubelementoDespesa || '',
        });
      } else {
        if (vinculo?.idEntidade) {
          DescricaoEntregaApi.getList(vinculo.idEntidade)
            .then(list => {
              if (Array.isArray(list) && list.length === 1) {
                setFormData(prev => ({ ...prev, descricaoEntrega: list[0].descricao }));
              }
            })
            .catch(err => console.error('Erro ao carregar descrições (auto):', err));
        }
      }
      setValidated(false);
    }
  }, [show, contrato, contratoPai, token]);

  const handleTipoAditivoChange = (e) => {
    const tipo = e.target.value;
    setTipoAditivo(tipo);
    if (contratoPai && tipo) {
      axios
        .get(`${API_BASE_URL.CONTRATO}/proximoNumAditivo/${contratoPai.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => {
          setFormData(prev => ({ ...prev, numContrato: `${contratoPai.numContrato} AD${res.data}` }));
        })
        .catch(() => {
          setFormData(prev => ({ ...prev, numContrato: `${contratoPai.numContrato} AD001` }));
        });

      if (tipo === 'QUANTIDADE' || tipo === 'AJUSTE_PRECO' || tipo === 'PRAZO' || tipo === 'VALOR') {
        axios
          .get(`${API_BASE_URL.CONTRATO_ITEM}/contrato/${contratoPai.id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(res => {
            let itensPai = (res.data || []).map(item => ({
              ...item,
              quantidadeOriginal: item.quantidade,
              valorUnitOriginal: item.valorUnit,
            }));
            if (tipo === 'PRAZO') {
              itensPai = itensPai
                .map(item => ({ ...item, quantidade: (item.quantidade || 0) - (item.qtdePedida || 0) }))
                .filter(item => item.quantidade > 0);
            }
            setItensAditivo(itensPai);
          })
          .catch(() => setItensAditivo([]));
      } else {
        setItensAditivo([]);
      }
    }
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleChangeItemAditivo = (index, field, value) => {
    setItensAditivo(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: parseFloat(value) || 0 };
      return updated;
    });
  };

  const [showDescricaoPicker, setShowDescricaoPicker] = useState(false);

  const formatarCodigo = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 17);
    const partes = [
      digits.slice(0, 2),
      digits.slice(2, 5),
      digits.slice(5, 9),
      digits.slice(9, 10),
      digits.slice(10, 13),
      digits.slice(13, 17),
    ];
    return partes.filter(p => p).join('.');
  };

  const handleDescricaoSelect = (descricao) => {
    setFormData(prev => ({ ...prev, descricaoEntrega: descricao }));
    setShowDescricaoPicker(false);
  };

  if (!show) return null;

  // Handler for FornecedorPicker selection
  const handleFornecedorSelect = (fornecedor) => {
    setFormData(prev => ({ ...prev, idFornecedor: fornecedor.idFornecedor }));
    setShowFornecedorPicker(false);
  };

  const handleAcaoSelect = (acao) => {
    setFormData(prev => ({ ...prev, idAcaoGovernamental: acao.codigo }));
    setShowAcaoPicker(false);
  };

  const handleFonteSelect = (fonte) => {
    setFormData(prev => ({ ...prev, idFonteRecurso: fonte.codigo }));
    setShowFontePicker(false);
  };

  const handleElementoSelect = (elemento) => {
    setFormData(prev => ({ ...prev, idElementoDespesa: elemento.codigo, idSubelementoDespesa: '' }));
    setShowElementoPicker(false);
  };

  const handleSubelementoSelect = (subelemento) => {
    setFormData(prev => ({ ...prev, idSubelementoDespesa: subelemento.codigo }));
    setShowSubelementoPicker(false);
  };

  const validateForm = () => {
    const errors = [];
    const warnings = [];

    if (!formData.objeto) errors.push('Objeto');
    if (!formData.dataInicio) errors.push('Data de Início');
    if (!formData.dataFim) errors.push('Data de Fim');
    if (formData.nomeModalidade && !formData.numModalidade) errors.push('Nº da Modalidade');

    if (!formData.idAcaoGovernamental) warnings.push('Ação Governamental');
    if (!formData.idFonteRecurso) warnings.push('Fonte de Recurso');
    if (!formData.idElementoDespesa) warnings.push('Elemento de Despesa');
    if (!formData.idSubelementoDespesa) warnings.push('Subelemento de Despesa');
    if (!formData.numProcesso) warnings.push('Nº do Processo');
    if (!formData.nomeModalidade) warnings.push('Modalidade');

    return { errors, warnings };
  };

  const doSave = () => {
    setLoading(true);
    const cleanData = {
      ...formData,
      idElementoDespesa: formData.idElementoDespesa || null,
      idSubelementoDespesa: formData.idSubelementoDespesa || null,
      idFonteRecurso: formData.idFonteRecurso || null,
      idAcaoGovernamental: formData.idAcaoGovernamental || null,
    };

    if (isAditivo && contratoPai) {
      cleanData.tipoCadastro = 'ADITIVO';
      cleanData.idContratoPai = contratoPai.id;
      cleanData.tipoAditivo = tipoAditivo;
      cleanData.justificativa = justificativa || null;
      if (['QUANTIDADE', 'AJUSTE_PRECO', 'PRAZO', 'VALOR'].includes(tipoAditivo) && itensAditivo.length > 0) {
        cleanData.itens = itensAditivo.map(item => ({
          id: null,
          idContrato: null,
          descricao: item.descricao,
          marca: item.marca,
          unidade: item.unidade,
          quantidade: item.quantidade,
          valorUnit: item.valorUnit,
          bloqueado: false,
        }));
      }
    }

    const payloadToSend = { ...cleanData, idEntidade: vinculo?.idEntidade, usuario: user?.login || '' };
    console.log('Payload Contrato enviado:', payloadToSend);
    const result = onSave(cleanData);
    if (result && typeof result.then === 'function') {
      result
        .then(() => {
          setLoading(false);
          onClose();
          showDefaultModal('success', contrato ? 'Contrato atualizado com sucesso!' : (isAditivo ? 'Aditivo cadastrado com sucesso!' : 'Contrato cadastrado com sucesso!'));
        })
        .catch(err => {
          setLoading(false);
          const msg = err?.response?.data?.error || 'Erro ao salvar contrato. Verifique os dados e tente novamente.';
          showDefaultModal('error', msg);
        });
    } else {
      setLoading(false);
      onClose();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mostrarEscolha || mostrarSelecaoPai) return;
    setValidated(true);
    if (!formData.numContrato || !formData.idFornecedor) return;
    if (isAditivo && !tipoAditivo) return;
    if (isAditivo && !justificativa) return;
    const { errors, warnings } = validateForm();
    if (errors.length > 0 || warnings.length > 0) {
      setValidationErrors(errors);
      setValidationWarnings(warnings);
      setShowSaveValidation(true);
      return;
    }
    doSave();
  };

  // Mensagens de validação para o rodapé
  let validationMsg = '';
  if (validated) {
    if (!formData.numContrato) validationMsg = 'Por favor, informe o número do contrato.';
    else if (!formData.idFornecedor) validationMsg = 'Por favor, selecione o fornecedor.';
    else if (isAditivo && !tipoAditivo) validationMsg = 'Por favor, selecione o tipo de aditivo.';
    else if (isAditivo && !justificativa) validationMsg = 'Por favor, informe a justificativa (Art. 124, Lei 14.133/2021).';
  }

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div
            className="modal-header text-white"
            style={{
              background:
                'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
              padding: '0.25rem 0.75rem', // altura reduzida
              minHeight: 36,
            }}
          >
            <h5 className="modal-title">
              {contrato
                ? (contrato.tipoCadastro === 'ADITIVO' ? 'Editar Aditivo' : 'Editar Contrato')
                : (isAditivo ? 'Novo Aditivo' : (modo === 'NOVO' ? 'Novo Contrato' : 'Novo Contrato ou Aditivo'))}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              disabled={loading}
              title="Fechar"
            ></button>
          </div>
          <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            {mostrarEscolha && (
              <div className="text-center py-5">
                <h6 className="fw-semibold mb-1">O que deseja cadastrar?</h6>
                <p className="text-muted small mb-4">Escolha o tipo de cadastro para continuar.</p>
                <div className="d-flex justify-content-center gap-3 flex-wrap">
                  <button
                    type="button"
                    className="btn btn-primary px-4 py-3"
                    onClick={() => setModo('NOVO')}
                    style={{ minWidth: '220px' }}
                  >
                    <i className="bi bi-file-earmark-plus me-2"></i>
                    Novo Contrato
                  </button>
                  <button
                    type="button"
                    className="btn btn-info text-white px-4 py-3"
                    onClick={() => setModo('ADITIVO')}
                    style={{ minWidth: '220px' }}
                  >
                    <i className="bi bi-journal-plus me-2"></i>
                    Aditivo
                  </button>
                </div>
              </div>
            )}

            {mostrarSelecaoPai && (
              <div className="py-4">
                <h6 className="fw-semibold mb-1">Aditivo de Contrato</h6>
                <p className="text-muted small mb-3">
                  Selecione o contrato a ser aditivado. O formulário só será liberado após a escolha.
                </p>
                <div className="mb-3">
                  <label className="form-label small fw-semibold">
                    Contrato a aditivar <span className="text-danger">*</span>
                  </label>
                  <div className="input-group input-group-sm">
                    <input
                      type="text"
                      className="form-control"
                      value={contratoPaiSelecionado
                        ? `${contratoPaiSelecionado.numContrato} - ${contratoPaiSelecionado.fornecedor?.nome || contratoPaiSelecionado.nomeFornecedor || ''}`
                        : ''}
                      placeholder="Clique para buscar o contrato..."
                      readOnly
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowContratoPicker(true)}
                      title="Buscar contrato"
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    {contratoPaiSelecionado && (
                      <button
                        type="button"
                        className="btn btn-outline-danger"
                        onClick={() => setContratoPaiSelecionado(null)}
                        title="Limpar seleção"
                      >
                        <i className="bi bi-x"></i>
                      </button>
                    )}
                  </div>
                  {contratosParaAditivar.length === 0 && (
                    <small className="text-muted d-block mt-1">
                      Nenhum contrato disponível para aditivo no ano selecionado.
                    </small>
                  )}
                </div>
                <ContratoPicker
                  show={showContratoPicker}
                  contratos={contratosParaAditivar}
                  onSelect={c => {
                    setContratoPaiSelecionado(c);
                    setShowContratoPicker(false);
                  }}
                  onClose={() => setShowContratoPicker(false)}
                />
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={() => setModo('')}
                  >
                    <i className="bi bi-arrow-left me-1"></i>
                    Voltar
                  </button>
                </div>
              </div>
            )}

            {!mostrarEscolha && !mostrarSelecaoPai && (
            <form onSubmit={handleSubmit} noValidate>
              <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">
                      Número do Contrato <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${validated && !formData.numContrato ? 'is-invalid' : ''}`}
                      name="numContrato"
                      value={formData.numContrato}
                      onChange={handleChange}
                      maxLength={20}
                      placeholder="Ex: 001/2024"
                      disabled={loading || isAditivo}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">
                      Fornecedor <span className="text-danger">*</span>
                    </label>
                    <div className="input-group input-group-sm">
                      <input
                        type="text"
                        className={`form-control ${validated && !formData.idFornecedor ? 'is-invalid' : ''}`}
                        value={
                          fornecedores.find(f => f.idFornecedor === formData.idFornecedor)
                            ? `${fornecedores.find(f => f.idFornecedor === formData.idFornecedor).nome} - ${fornecedores.find(f => f.idFornecedor === formData.idFornecedor).cpfOrCnpj}`
                            : ''
                        }
                        placeholder="Clique para buscar o fornecedor..."
                        readOnly
                        disabled={loading}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowFornecedorPicker(true)}
                        disabled={loading || isAditivo}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      {formData.idFornecedor && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => setFormData(prev => ({ ...prev, idFornecedor: '' }))}
                          disabled={loading || isAditivo}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      )}
                      <FornecedorPicker
                        show={showFornecedorPicker}
                        fornecedores={fornecedores}
                        selectedId={formData.idFornecedor}
                        onSelect={handleFornecedorSelect}
                        onClose={() => setShowFornecedorPicker(false)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {isAditivo && (
                <>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label small fw-semibold">
                          Tipo de Aditivo <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control form-control-sm"
                          name="tipoAditivo"
                          value={tipoAditivo}
                          onChange={handleTipoAditivoChange}
                          disabled={loading || !!contrato}
                          required={isAditivo}
                        >
                          <option value="">Selecione...</option>
                          <option value="PRAZO">Prazo (Art. 107)</option>
                          <option value="VALOR">Vigência e Valor (Art. 124, I, "a")</option>
                          <option value="AJUSTE_PRECO">Ajuste de Preço (Art. 124, II, "d")</option>
                          <option value="QUANTIDADE">Quantidade (Art. 124, I, "b")</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label className="form-label small fw-semibold">Contrato Pai</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={`${contratoPai?.numContrato || ''} - ${contratoPai?.fornecedor?.nome || ''}`}
                          readOnly
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">
                      Justificativa <span className="text-danger">*</span>
                      <small className="text-muted ms-1">(Art. 124, Lei 14.133/2021)</small>
                    </label>
                    <textarea
                      className="form-control form-control-sm"
                      rows={3}
                      value={justificativa}
                      onChange={(e) => setJustificativa(e.target.value)}
                      placeholder="Descreva a justificativa para o aditivo conforme Art. 124 da Lei 14.133/2021..."
                      disabled={loading}
                    />
                  </div>

                  {(tipoAditivo && ['QUANTIDADE', 'AJUSTE_PRECO', 'PRAZO', 'VALOR'].includes(tipoAditivo) && itensAditivo.length > 0) && (
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">
                        Itens do Aditivo
                        {tipoAditivo === 'QUANTIDADE' && (
                          <small className="text-muted ms-1">(Art. 125 - acréscimo/supressão de até 25%)</small>
                        )}
                        {tipoAditivo === 'VALOR' && (
                          <small className="text-muted ms-1">(edita valores e vigência - acréscimo/supressão de valores de até 25%)</small>
                        )}
                        {tipoAditivo === 'AJUSTE_PRECO' && (
                          <small className="text-muted ms-1">(Art. 130 - restabelecimento do equilíbrio)</small>
                        )}
                        {tipoAditivo === 'PRAZO' && (
                          <small className="text-muted ms-1">(somente leitura - apenas prazo alterado)</small>
                        )}
                      </label>
                      <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                        <table className="table table-sm table-bordered mb-0">
                          <thead className="table-light" style={{ position: 'sticky', top: 0 }}>
                            <tr>
                              <th style={{ width: '5%' }}>#</th>
                              <th>Descrição</th>
                              <th>Unidade</th>
                              <th style={{ width: '12%' }}>Qtde</th>
                              <th style={{ width: '15%' }}>V. Unit</th>
                              <th style={{ width: '15%' }}>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {itensAditivo.map((item, idx) => (
                              <tr key={idx}>
                                <td>{idx + 1}</td>
                                <td className="small">{item.descricao}</td>
                                <td>{item.unidade}</td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={item.quantidade}
                                    onChange={(e) => handleChangeItemAditivo(idx, 'quantidade', e.target.value)}
                                    min={0}
                                    step="0.01"
                                    disabled={loading || tipoAditivo === 'AJUSTE_PRECO' || tipoAditivo === 'PRAZO' || tipoAditivo === 'VALOR'}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={item.valorUnit}
                                    onChange={(e) => handleChangeItemAditivo(idx, 'valorUnit', e.target.value)}
                                    min={0}
                                    step="0.01"
                                    disabled={loading || tipoAditivo === 'QUANTIDADE' || tipoAditivo === 'PRAZO'}
                                  />
                                </td>
                                <td className="small fw-semibold">
                                  {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
                                    (item.quantidade || 0) * (item.valorUnit || 0)
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </>
              )}

              <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Nº Processo</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="numProcesso"
                      value={formData.numProcesso}
                      onChange={handleChange}
                      maxLength={20}
                      placeholder="Ex: 001/2024"
                      disabled={loading || isAditivo}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Modalidade</label>
                    <select
                      className="form-control form-control-sm"
                      name="nomeModalidade"
                      value={formData.nomeModalidade}
                      onChange={handleChange}
                      disabled={loading || isAditivo}
                    >
                      <option value="">Selecione...</option>
                      {modalidades.map(mod => (
                        <option key={mod.id} value={mod.descricao}>
                          {mod.descricao}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Nº Modalidade</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="numModalidade"
                      value={formData.numModalidade}
                      onChange={handleChange}
                      maxLength={20}
                      placeholder="Ex: 001/2024"
                      disabled={loading || isAditivo}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Data Início</label>
                    <DataMaskInput name="dataInicio" value={formData.dataInicio} onChange={handleChange} disabled={loading || isAditivo} />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Data Fim</label>
                    <DataMaskInput
                      name="dataFim"
                      value={formData.dataFim}
                      onChange={handleChange}
                      disabled={loading || (isAditivo && tipoAditivo && tipoAditivo !== 'PRAZO' && tipoAditivo !== 'VALOR')}
                    />
                    {isAditivo && tipoAditivo === 'PRAZO' && (
                      <small className="text-info">Nova data de vigência (Art. 107)</small>
                    )}
                    {isAditivo && tipoAditivo === 'VALOR' && (
                      <small className="text-info">Data de fim opcional - permite prazo e valor juntos</small>
                    )}
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Data Rescisão</label>
                    <DataMaskInput name="dataRescisao" value={formData.dataRescisao} onChange={handleChange} disabled={loading || isAditivo} />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label small fw-semibold">Objeto</label>
                <textarea
                  className="form-control form-control-sm"
                  rows={2}
                  name="objeto"
                  value={formData.objeto}
                  onChange={handleChange}
                  placeholder="Descreva o objeto do contrato..."
                  disabled={loading || isAditivo}
                />
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Ação Governamental</label>
                    <div className="input-group input-group-sm">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          acoes.find(a => a.codigo === formData.idAcaoGovernamental)
                            ? `${formatarCodigo(acoes.find(a => a.codigo === formData.idAcaoGovernamental).codigo)} - ${acoes.find(a => a.codigo === formData.idAcaoGovernamental).descricao}`
                            : ''
                        }
                        placeholder="Clique para buscar a ação..."
                        readOnly
                        disabled={loading || isAditivo}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowAcaoPicker(true)}
                        disabled={loading || isAditivo}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      {formData.idAcaoGovernamental && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => setFormData(prev => ({ ...prev, idAcaoGovernamental: '' }))}
                          disabled={loading || isAditivo}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Elemento de Despesa</label>
                    <div className="input-group input-group-sm">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          elementos.find(e => e.codigo === formData.idElementoDespesa)
                            ? `${elementos.find(e => e.codigo === formData.idElementoDespesa).codigo} - ${elementos.find(e => e.codigo === formData.idElementoDespesa).descricao}`
                            : ''
                        }
                        placeholder="Clique para buscar o elemento..."
                        readOnly
                        disabled={loading || isAditivo}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowElementoPicker(true)}
                        disabled={loading || isAditivo}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      {formData.idElementoDespesa && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => setFormData(prev => ({ ...prev, idElementoDespesa: '', idSubelementoDespesa: '' }))}
                          disabled={loading || isAditivo}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Subelemento de Despesa</label>
                    <div className="input-group input-group-sm">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          subelementos.find(s => s.codigo === formData.idSubelementoDespesa && s.idElemento === formData.idElementoDespesa)
                            ? `${subelementos.find(s => s.codigo === formData.idSubelementoDespesa && s.idElemento === formData.idElementoDespesa).codigo} - ${subelementos.find(s => s.codigo === formData.idSubelementoDespesa && s.idElemento === formData.idElementoDespesa).descricao}`
                            : ''
                        }
                        placeholder="Clique para buscar o subelemento..."
                        readOnly
                        disabled={loading || isAditivo || !formData.idElementoDespesa}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowSubelementoPicker(true)}
                        disabled={loading || isAditivo || !formData.idElementoDespesa}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      {formData.idSubelementoDespesa && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => setFormData(prev => ({ ...prev, idSubelementoDespesa: '' }))}
                          disabled={loading || isAditivo}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label small fw-semibold">Fonte de Recurso</label>
                    <div className="input-group input-group-sm">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          fontes.find(f => f.codigo === formData.idFonteRecurso)
                            ? `${fontes.find(f => f.codigo === formData.idFonteRecurso).codigo} - ${fontes.find(f => f.codigo === formData.idFonteRecurso).descricao}`
                            : ''
                        }
                        placeholder="Clique para buscar a fonte..."
                        readOnly
                        disabled={loading || isAditivo}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowFontePicker(true)}
                        disabled={loading || isAditivo}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      {formData.idFonteRecurso && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => setFormData(prev => ({ ...prev, idFonteRecurso: '' }))}
                          disabled={loading || isAditivo}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label small fw-semibold">Descrição de Entrega</label>
                <div className="d-flex">
                  <textarea
                    className="form-control flex-grow-1"
                    name="descricaoEntrega"
                    value={formData.descricaoEntrega}
                    onChange={handleChange}
                    rows={3}
                    disabled={isAditivo}
                  />
                  <div className="d-flex flex-column ms-2">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm mb-2"
                      style={{ height: '32px', paddingTop: '4px', paddingBottom: '4px' }}
                      onClick={() => setShowDescricaoPicker(true)}
                      disabled={isAditivo}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    {formData.descricaoEntrega && (
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        style={{ height: '32px', paddingTop: '4px', paddingBottom: '4px' }}
                        onClick={() => setFormData(prev => ({ ...prev, descricaoEntrega: '' }))}
                        disabled={isAditivo}
                      >
                        <i className="bi bi-x"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
            )}
          </div>
          <div className="modal-footer d-flex justify-content-between align-items-center">
            <div className="text-danger small flex-grow-1 text-start">
              {validationMsg}
            </div>
            {showDescricaoPicker && (
              <DescricaoEntregaPicker show={showDescricaoPicker} onClose={() => setShowDescricaoPicker(false)} onSelect={handleDescricaoSelect} />
            )}
            {showAcaoPicker && (
              <AcaoGovernamentalPicker
                show={showAcaoPicker}
                acoes={acoes}
                selectedCodigo={formData.idAcaoGovernamental}
                onSelect={handleAcaoSelect}
                onClose={() => setShowAcaoPicker(false)}
              />
            )}
            {showFontePicker && (
              <FonteRecursoPicker
                show={showFontePicker}
                fontes={fontes}
                selectedCodigo={formData.idFonteRecurso}
                onSelect={handleFonteSelect}
                onClose={() => setShowFontePicker(false)}
              />
            )}
            {showElementoPicker && (
              <ElementoDespesaPicker
                show={showElementoPicker}
                elementos={elementos}
                selectedCodigo={formData.idElementoDespesa}
                onSelect={handleElementoSelect}
                onClose={() => setShowElementoPicker(false)}
              />
            )}
            {showSubelementoPicker && (
              <SubelementoDespesaPicker
                show={showSubelementoPicker}
                subelementos={subelementos.filter(s => s.idElemento === formData.idElementoDespesa)}
                selectedCodigo={formData.idSubelementoDespesa}
                onSelect={handleSubelementoSelect}
                onClose={() => setShowSubelementoPicker(false)}
              />
            )}
            <div>
              <button
                type="button"
                className="btn btn-secondary btn-sm me-2"
                onClick={onClose}
                disabled={loading}
              >
                <i className="bi bi-x-circle me-1"></i>
                Cancelar
              </button>
              {!mostrarEscolha && !mostrarSelecaoPai && (
              <button
                type="submit"
                className="btn btn-primary btn-sm"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1"></span>
                    Salvando...
                  </>
                ) : (
                  <>
                    <i className="bi bi-check-circle me-1"></i>
                    Salvar
                  </>
                )}
              </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
      <SaveValidationModal
        show={showSaveValidation}
        errors={validationErrors}
        warnings={validationWarnings}
        onClose={() => { setShowSaveValidation(false); setValidationErrors([]); setValidationWarnings([]); }}
        onConfirm={() => { setShowSaveValidation(false); setValidationErrors([]); setValidationWarnings([]); doSave(); }}
      />
    </div>
  );
}

export default ContratoModal;
